import { Avatar, Box, Container, Grid, Typography } from "@mui/material";
import React, { useState, useRef, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import NeoButton from "../NeoButton";
import { useAuthStore } from "../../@shared/store/useAuthStore";
import { MainContext } from "../../App";
import { Add, ArrowForwardIos, MenuRounded } from "@mui/icons-material";
import { useTutorial } from "../../@shared/utils/useTutorial";
import TutorialInfinityOrb from "../TutorialInfinityOrb";

const IOIntro = () => {
  const { Theme, setInfo, setMessage } = React.useContext(MainContext);
  const { userData } = useAuthStore();
  const { progress, sequence, advanceStep } = useTutorial(userData?.id);
  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        position: "absolute",
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
        zIndex: 1000,
      }}
    >
      <Box
        sx={{
          width: "100%",
          height: "100%",
          position: "relative",
          zIndex: 1000,
        }}
      >
        <Box
          sx={{
            position: "absolute",
            left: sequence?.orbPosition.left,
            top: {
              xs: "20%",
              md: sequence?.orbPosition.top,
            },
            transform: `scale(${sequence?.orbPosition.scale})`,
            zIndex: 2001,
          }}
        >
          <TutorialInfinityOrb />
        </Box>
        {/* IO Dialogue Box */}
        <Box
          sx={{
            width: { xs: "85%", md: "50%" },
            height: { xs: "40%", md: "30%" },
            position: "absolute",
            left: "50%",
            // top: "50%",
            bottom: "2%",
            transform: "translate(-50%, 0%)",
            zIndex: 1,
            background: "white",
            borderRadius: 2,
            padding: 2,
          }}
        >
          <Box
            sx={{
              width: "100%",
              height: "100%",
              position: "relative",
              alignItems: "center",
              display: "flex",
              flexFlow: "column",
              justifyContent: "center",
            }}
          >
            <Typography
              variant="h6"
              sx={{
                mb: 7,
                whiteSpace: "pre-line",
                width: "100%",
                textAlign: "center",
                position: "relative",
                top: { xs: "8px", md: "0px" },
              }}
            >
              {sequence?.steps[progress.currentStepIndex].text}
            </Typography>
            <Box
              sx={{
                width: "fit-content",
                height: "fit-content",
                position: "absolute",
                top: "-35px",
                right: "5px",
              }}
            >
              <NeoButton
                isIcon
                icon={<ArrowForwardIos />}
                color={Theme.palette.tirciary.main}
                onClick={advanceStep}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default IOIntro;
